module.exports = __webpack_public_path__ + "img/live2d-mask-bg.af2ca674.png";